'use es6';

// This safely works on strings of length >= 0
const capitalizeFirstLetter = (str = '') => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
export default capitalizeFirstLetter;